import React from 'react';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import { Row } from 'components/Containers/Row/Row';
import { SUGGESTED_AUTO_LOAN_OFFERS } from 'types/morph.pagePosition.constants';
import AutoLoanRefinanceSavingsOffer from 'components/Offers/AutoLoanRefinanceSavingsOffer';
import { formatApr } from 'helpers/number';
import { useConfig } from 'hook/config.hook';
import { formatIncome } from "helpers/money.helper";

const SuggestedAutoLoanOffersView = ({
  datatestid,
  pageName,
  autoLoanOffers,
  currentLoanDetails,
  onLinkClickCallback,
  modulePosition,
  seenPixel,
  ...props
}) => {
  
  const { config } = useConfig();
  const savingsAmount = (
    currentLoanDetails.monthlyPayment - autoLoanOffers[0]['monthlyPayment']
  ).toFixed(2);
  let autoLoanSectionTooltip = '';
  if (config) {
    autoLoanSectionTooltip =
      config.disclaimers.autoLoans.overviewAutoLoanHowIsThisCalculated;
    autoLoanSectionTooltip = autoLoanSectionTooltip
      .replace(
        '{monthlyPayment}',
        formatIncome(currentLoanDetails.monthlyPayment),
      )
      .replace('{apr}', `${formatApr(currentLoanDetails.apr)}%`)
      .replace('{term}', currentLoanDetails.term);
  }
  return (
    <div>
      {seenPixel}
      <Row>
        <StaticOfferContainer
          offerMetadataList={autoLoanOffers}
          showComparison={true}
          termsPostfix={' mos'}
          eventHandler={props.eventHandler}
          pagePosition={SUGGESTED_AUTO_LOAN_OFFERS}
          autoLoanTemplate={AutoLoanRefinanceSavingsOffer}
          modulePosition={modulePosition}
          savingsAmount={savingsAmount}
          autoLoanSectionTooltip={autoLoanSectionTooltip}
          autoLoanName={currentLoanDetails.name}
          monthlyPayment={currentLoanDetails.monthlyPayment}
          currentLoanDetails={currentLoanDetails}
        />
      </Row>
    </div>
  );
};

export { SuggestedAutoLoanOffersView };
